//引入接口文档
import req from '@/utils/req.js'

//平台科室添加
export function addPlatDepartment(params) {
    return req.post("/admin/platform-department",params);
}
//平台科室更新
export function updatePlatDepartment(params) {
    return req.put("/admin/platform-department",params);
}
//平台科室分页查询
export function queryPlatDepartment(params) {
    return req.post("/admin/platform-department/page",params);
}

//开放科室添加
export function addOpenDepartment(params) {
  return req.post("/admin/open-department",params);
}
//开放科室更新
export function updateOpenDepartment(params) {
  return req.put("/admin/open-department",params);
}
//开放科室分页查询
export function queryOpenDepartment(params) {
  return req.post("/admin/open-department/search",params);
}

//标准科室添加
export function addStandardDepartment(params) {
  return req.post("/admin/standard-department",params);
}
//标准科室更新
export function updateStandardDepartment(params) {
  return req.put("/admin/standard-department",params);
}
//标准科室分页查询
export function queryStandardDepartment(params) {
  return req.post("/admin/standard-department/page",params);
}


//平台医院列表查询
export function queryPlatformList(params) {
  return req.post("/admin/platform/list",params);
}

//标准科室选择列表
export function selectDepartmentLevel(params) {
  return req.post("/admin/standard-department/select",params);
}
//机构科室列表
export function institutionalDepartment (params) {
  return req.post("/admin/platform-department/pullDown",params);
}
//医院列表查询
export function queryHospitalList(params) {
  return req.post("/admin/hospital/list",params);
}

//线下医院置顶
export function updateTopState(params) {
  return req.get("/admin/open-department/updateTopState",params);
}

//互医平台置顶
export function updatePlatTopState(params) {
  return req.get("/admin/platform-department/updateTopState",params);
}
//机构置顶
export function updateOrgTopState(params) {
  return req.get("/admin/open-department/updateTopState",params);
}
//获取未补全的数量
export function getDepartIncompleteCount(params) {
  return req.get(`/admin/open-department/getIncompleteCount`,params)
}

//开放科室列表查询
export function queryOpenDepartmentList(params) {
  return req.post("/admin/open-department/list",params);
}

//科室列表查询
export function queryDepartmentList(params) {
  return req.post("/admin/open-department/listByName",params);
}
